"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LocationAutoCompleteInput = require("./LocationAutoCompleteInput");
Object.keys(_LocationAutoCompleteInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LocationAutoCompleteInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LocationAutoCompleteInput[key];
    }
  });
});